import React, { useEffect } from "react";
import { Toast, ToastContainer } from "react-bootstrap";

const ToastMessage = ({ show, onClose, message, variant = "success" }) => {
  // 🔹 Scroll to top when toast opens
  useEffect(() => {
    if (show) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [show]);

  return (
    <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999 }}>
      <Toast onClose={onClose} show={show} bg={variant} delay={5000} autohide>
        <Toast.Body className="text-white d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <i className="bi bi-check-circle-fill me-2 fs-5"></i>
            <strong>{message}</strong>
          </div>
          <button
            type="button"
            className="btn-close  ms-2 mb-1"
            aria-label="Close"
            onClick={onClose}
          ></button>
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default ToastMessage;
